import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";

const getFormSession = async (form, sessionID) => {
  try {
    const docRef = doc(db, `IT/forms/${form}/${sessionID}`);
    const sessionSnap = await getDoc(docRef);

    if (sessionSnap.exists()) {
      return sessionSnap.data();
    } else {
      console.log("No such document!");
      return null;
    }
  } catch (err) {
    console.log("Error getting Form Session:", err);
  }
};

export default getFormSession;
